import {ChangeDetectionStrategy, Component, HostBinding, HostListener, Input} from '@angular/core';
import {TypeaheadComponent} from './typeahead.component';

@Component({
  selector: 'mtg-typeahead-option',
  templateUrl: './typeahead-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeaheadOptionComponent {
  @Input()
  value: any;

  @HostBinding('class.typeahead-option')
  defaultClass = true;

  @HostListener('click')
  onClick() {
    this.typeahead.selectedItem(this.value);
  }

  constructor(
    private typeahead: TypeaheadComponent,
  ) {}
}
